<template>
    <Transition name="info">
      <div class="artwork-detail" v-if="isShow">
        <div class="top" @click="close">
          <div class="close"><img src="@/assets/img/close.png"></div>
          <div class="logo" @click="goMain">
            <img src="@/assets/img/logo-black.png" />
          </div>
        </div>
        <div class="info">
          <div class="cover prison">
            <img :src="detail.cover.b" />
          </div>
          <div class="desc">
            <span class="name font-info-title">{{ detail.name }} · {{ detail.artist.name }}</span>
            <p class="material font-p pre-line" v-if="detail.material">{{ detail.material }}</p>
            <p class="size font-p en pre-line">{{ detail.size }}</p>
            <a class="font-link en" @click="goArtist()">About Artist</a>
          </div>
        </div>
      </div>
    </Transition>
</template>

<script>
export default {
  props:{
      detail:{
          type:Object,
          require:true
      },
  },
  data(){
      return {
          isShow:true,
      }
  },
  created(){
      this.show();
  },
  methods:{
      show(){
        // this.isShow=true;
        document.body.style.overflow="hidden";
      },
      close(){
        this.isShow=false;
        document.body.style.overflow="auto";
      },
      goMain(){
      console.log();
      this.$root.$vue.$router.push("/");
        this.close()
      },
      goArtist(){
        this.$root.$vue.$router.push("/artist/info?id="+this.detail.artist.id);
        this.close()
      }
  }
}
</script>
<style lang="less" scoped>

.info-enter-from{
  opacity: 0;
}
.info-enter-active{
  opacity: 0.5;
}
.info-enter-to {
    opacity: 1;
}
.info-leave-to {
    opacity: 0;
}


.artwork-detail{
  transition: all 0.3s ease;
  position: fixed;
  width: 100%;
  z-index: 1001;
  top:0px;
  left: 0px;
  background-color: #f3f3f3;
  pointer-events: auto;
  height: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .top{
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 1;
    height: 120px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 50px;
    .close{
      width: 18px;
      height: 15px;
      cursor: pointer;
    }
    .logo{
      width: 26px;
      height: 40px;
      cursor: pointer;
      display: none;
    }
  }
  .info{
    display: flex;
    justify-content: center;
    .cover{
      width: 734px;
      height: 870px;
    }
    .desc{
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: 96px;
      .name{
        margin-bottom: 8px;
      }
      a{
        cursor: pointer;
        margin-top: 24px;
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .artwork-detail{
    height: 100%;
    overflow-y: auto;
    justify-content: flex-start;
    &::before{
      display: block;
      content: "";
      height: 66px;
      width: 100%;
      flex-shrink: 0;
    }
    .top{
      position: fixed;
      height: 66px;
      padding: 0px 20px;
      background-color: #f3f3f3;
      border-bottom: 0.5px solid #4d4d4d;
      .close{
        width: 16px;
        height: 13px;
      }
      .logo{
        width: 21px;
        height: 32px;
        display: block;
      }
    }
    .info{
      margin-top: unset;
      display: block;
      width: 100%;
      padding: 20px;
      // justify-content: flex-start;
      // flex-direction: column;
      .cover{
        width: 100%;
        height: auto;
        margin-right: unset;
      }
      .prison{
        img{
          object-fit: unset;
        }
      }
      .desc{
        justify-content: flex-start;
        margin-left: 0px;
        margin-top: 20px;
        .name{
          margin-bottom: 12px;
        }
        p{
          line-height: 22px;
        }
        a{
          margin-top: 36px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/artwork/detail.vue